/**
 * Smooth Scroll
 */

(function() {
  'use strict';

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    
    if (!link || link.getAttribute('href') === '#') {
      return;
    }

    var target = document.querySelector(link.getAttribute('href'));
    
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      // Update URL without triggering scroll
      if (history.pushState) {
        history.pushState(null, null, link.getAttribute('href'));
      }
    }
  });
})();

